module.exports = __webpack_public_path__ + "img/alexandr.d2e8d0e4.jpg";